import React from "react";
import { Drawer, Tag } from "antd";

import { COULEURS_CATEGORIES, COULEUR_KIWEE, estKiwee, filenameJob } from "./categoriesFlux";
import { MessageNonRemonte, formaterDate, formaterDuree } from "./BarreFiltresMap";
import {
  COULEUR_EN_COURS,
  COULEURS_HISTORIQUE,
  STATUTS_META,
  jobsParCategorie,
  statutPrincipal,
} from "./filtresMap";

// Couleurs antd des Tag par statut (le "gris clair" de "sans" reste neutre).
const COULEUR_TAG = {
  erreur: "red",
  warning: "orange",
  grise: "default",
  ok: "green",
  sans: "default",
};

// Pastilles d'historique (3 derniers builds), cliquables -> logs du build.
function Historique({ job, onOpenLogs }) {
  const h = Array.isArray(job.history) ? job.history : [];
  return (
    <div className="map-hist" onClick={(e) => e.stopPropagation()}>
      {h.slice(0, 3).map((entree, i) => {
        const build = Array.isArray(entree) ? entree[1] : null;
        const statut = Array.isArray(entree) ? Number(entree[0]) : 3;
        const titre = Array.isArray(entree)
          ? `${formaterDate(entree[2]) || "Pas d'exécution"}${
              entree[3] ? " · " + formaterDuree(entree[3]) : ""
            }`
          : "";
        return (
          <button
            key={i}
            type="button"
            className="map-hist-p"
            style={{ background: COULEURS_HISTORIQUE[statut] || COULEURS_HISTORIQUE[3] }}
            title={titre}
            aria-label={`Historique ${i + 1} : ${titre}`}
            disabled={!build}
            onClick={(e) => {
              e.stopPropagation();
              onOpenLogs(job, i);
            }}
          />
        );
      })}
    </div>
  );
}

// Panneau lateral de detail d'un environnement. env : agregat (collecterEnvs) ; categorie :
// restreint le detail a une categorie (clic sur une case de la matrice / lentille hexagonale).
// onOpenLogs(job, indexHistorique|null) ouvre la modale de logs existante.
export function PanneauEnvironnement({ env, categorie, onClose, onOpenLogs }) {
  const sections = env ? jobsParCategorie(env, categorie) : [];
  return (
    <Drawer
      open={!!env}
      onClose={onClose}
      width={460}
      title={env ? `${env.group} · ${env.env}` : ""}
      destroyOnClose
    >
      {env && (
        <div className="map-panneau" data-testid="panneau-environnement">
          <div className="map-panneau-sous">
            {[env.server, env.vague].filter(Boolean).join(" · ")}
            {env.server || env.vague ? " · " : ""}
            {env.nonRemonte
              ? "Serveur non remonté"
              : `${env.jobs.length} traitement(s)${categorie ? ` · ${categorie}` : ""}`}
          </div>
          {env.nonRemonte && (
            <div>
              <p>
                <Tag color="purple">Non remonté</Tag>
              </p>
              <p>
                Serveur : {env.server || "—"}
                <br />
                Groupe : {env.group || "—"}
              </p>
              <MessageNonRemonte dernierBuild={env.dernierBuild} />
            </div>
          )}
          {env.sans && (
            <p>
              <Tag>Sans traitement</Tag> Aucun traitement n&apos;est rattaché à cet
              environnement.
            </p>
          )}
          {sections.map(({ categorie: cat, jobs }) => (
            <div key={cat}>
              <h4 className="map-panneau-cat">
                <span className="map-dot" style={{ background: COULEURS_CATEGORIES[cat] }} />
                {cat} · {jobs.length}
              </h4>
              {[...jobs]
                .sort(
                  (a, b) =>
                    STATUTS_META[statutPrincipal(b)].poids -
                    STATUTS_META[statutPrincipal(a)].poids
                )
                .map((job, i) => {
                  const statut = statutPrincipal(job);
                  return (
                    <div
                      key={`${job.traitement_id}-${i}`}
                      role="button"
                      tabIndex={0}
                      className="map-job"
                      onClick={() => onOpenLogs(job, null)}
                      onKeyDown={(e) => e.key === "Enter" && onOpenLogs(job, null)}
                    >
                      <div className="map-job-fn">
                        {job.name || filenameJob(job)}
                        {estKiwee(filenameJob(job)) && (
                          <Tag color={COULEUR_KIWEE} style={{ marginLeft: 6 }}>
                            KIWEE
                          </Tag>
                        )}
                      </div>
                      <Tag
                        className={`map-job-tag${job.running ? " running" : ""}`}
                        color={job.running ? COULEUR_EN_COURS : COULEUR_TAG[statut]}
                      >
                        {job.running ? "En cours" : STATUTS_META[statut].libelle}
                      </Tag>
                      <div className="map-job-meta">
                        {formaterDate(job.start_date_time) || "—"} ·{" "}
                        {formaterDuree(job.duration) || "—"}
                      </div>
                      <Historique job={job} onOpenLogs={onOpenLogs} />
                    </div>
                  );
                })}
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
}
